/*
  Orvenisa · JS nhỏ cho các section orv-*
  - Thanh thông báo (mobile): tự trượt + nút ‹ ›
  - Menu mobile (☰)
  - Review trang chủ: mỗi lần mở trang chọn ngẫu nhiên N review, mỗi review 1 sản phẩm khác nhau
  - Hero trang chủ: slideshow ảnh tự chuyển (mờ dần) + chấm bấm
  - Danh mục trang chủ: ảnh đại diện các sản phẩm của collection đổi lần lượt trong từng ô
  - Cómo comprar: nền xanh nhảy lần lượt qua từng bước (section bật "Hiệu ứng")
  - Cập nhật --header-height / --header-group-height cho Horizon (trang sản phẩm, giỏ hàng dùng biến này)
  Chạy an toàn khi section không có mặt; hỗ trợ Theme Editor (shopify:section:load / unload).
*/
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── Thanh thông báo ── */
  function initAnuncio(root) {
    var track = root.querySelector('.orv-an-track');
    if (!track || track.dataset.orvInit) return;
    track.dataset.orvInit = '1';

    var n = track.children.length;
    var i = 0;
    var timer = null;
    var delay = (parseFloat(root.getAttribute('data-orv-speed')) || 3.5) * 1000;

    function go(k) {
      if (!n) return;
      i = (k + n) % n;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
    }
    function auto() {
      clearInterval(timer);
      if (n < 2 || (reduceMotion && reduceMotion.matches)) return;
      timer = setInterval(function () { go(i + 1); }, delay);
    }

    track._orv = {
      step: function (d) { go(i + d); auto(); },
      show: function (k) { clearInterval(timer); go(k); },
      auto: auto,
      stop: function () { clearInterval(timer); }
    };
    auto();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-orv-an]');
    if (!btn) return;
    var root = btn.closest('[data-orv-anuncio]');
    var track = root && root.querySelector('.orv-an-track');
    if (track && track._orv) track._orv.step(parseInt(btn.getAttribute('data-orv-an'), 10));
  });

  /* ── Menu mobile ── */
  function initMenu(root) {
    var burger = root.querySelector('.orv-burger');
    var menu = root.querySelector('.orv-menu-m');
    if (!burger || !menu || burger.dataset.orvInit) return;
    burger.dataset.orvInit = '1';

    function set(on) {
      menu.classList.toggle('abierto', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      burger.setAttribute('aria-label', on ? burger.dataset.labelClose : burger.dataset.labelOpen);
      updateHeights();
    }
    burger.addEventListener('click', function () { set(!menu.classList.contains('abierto')); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { set(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('abierto')) set(false);
    });
  }

  /* ── Chiều cao header cho Horizon ── */
  function updateHeights() {
    var cab = document.querySelector('.orv-cab');
    var group = document.getElementById('header-group');
    if (!cab || !group) return;
    var groupHeight = 0;
    group.querySelectorAll(':scope > .shopify-section').forEach(function (el) {
      groupHeight += el.offsetHeight;
    });
    document.body.style.setProperty('--header-height', Math.round(cab.offsetHeight) + 'px');
    document.body.style.setProperty('--header-group-height', Math.round(groupHeight) + 'px');
  }

  var ro = null;
  function watchHeights() {
    updateHeights();
    if (!('ResizeObserver' in window)) return;
    if (ro) ro.disconnect();
    ro = new ResizeObserver(updateHeights);
    document.querySelectorAll('#header-group > .shopify-section').forEach(function (el) { ro.observe(el); });
  }

  /* ── Review trang chủ: chọn ngẫu nhiên N review, không trùng sản phẩm ── */
  function initRvPool(grid) {
    if (grid._orvRv || window.Shopify && window.Shopify.designMode) return;
    grid._orvRv = true;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.orv-rv'));
    var n = parseInt(grid.getAttribute('data-n'), 10) || 3;
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    var vistos = {};
    var elegidos = [];
    cards.forEach(function (c) {
      var k = c.getAttribute('data-prod') || '';
      if (elegidos.length < n && !vistos[k]) { vistos[k] = 1; elegidos.push(c); }
    });
    if (!elegidos.length) return;
    cards.forEach(function (c) { c.hidden = elegidos.indexOf(c) === -1; });
    elegidos.forEach(function (c) { grid.appendChild(c); });
  }

  /* ── Hero: slideshow ảnh ── */
  /* Ảnh slide chưa nạp (data-src / data-srcset, xem sections/orv-hero.liquid) → gán srcset/src */
  function cargarHs(sl) {
    var img = sl && sl.querySelector('img[data-src], img[data-srcset]');
    if (!img) return;
    var ss = img.getAttribute('data-srcset'), u = img.getAttribute('data-src');
    if (ss) { img.setAttribute('srcset', ss); img.removeAttribute('data-srcset'); }
    if (u) { img.setAttribute('src', u); img.removeAttribute('data-src'); }
  }
  /* Chạy fn sau window load, lúc trình duyệt rảnh → không tranh băng thông với ảnh LCP */
  function trasCarga(fn) {
    function idle() { if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 2000 }); else setTimeout(fn, 200); }
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
  }

  function initHeroSlides(box) {
    if (box._orvHs) return;
    var slides = box.querySelectorAll('.orv-hs-slide');
    var dots = box.querySelectorAll('.orv-hs-dot');
    var n = slides.length;
    if (n < 2) return;
    // slide kế tiếp nạp sẵn sau window load; mỗi lần chuyển → nạp slide đích + slide sau nó
    trasCarga(function () { cargarHs(slides[1]); });
    var delay = (parseInt(box.getAttribute('data-seg'), 10) || 4) * 1000;
    var i = 0;
    var timer;
    function go(k) {
      i = (k + n) % n;
      cargarHs(slides[i]); cargarHs(slides[(i + 1) % n]);
      slides.forEach(function (sl, j) { sl.classList.toggle('on', j === i); });
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === i);
        if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function auto() {
      clearInterval(timer);
      if (reduceMotion && reduceMotion.matches) return;
      timer = setInterval(function () { go(i + 1); }, delay);
    }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); auto(); }); });
    box._orvHs = {
      show: function (k) { clearInterval(timer); go(k); },
      auto: auto,
      stop: function () { clearInterval(timer); }
    };
    auto();
  }

  /* ── Danh mục: ảnh đại diện các sản phẩm của collection đổi lần lượt ── */
  /* Chỉ chạy khi ô nằm trong khung nhìn; ảnh kế tiếp nạp trước 1 nhịp (cargarHs). Các ô lệch pha nhau cho đỡ giật cùng lúc. */
  function initColSlides(box, idx) {
    if (box._orvCs) return;
    var slides = box.querySelectorAll('.orv-cs-slide');
    var n = slides.length;
    if (n < 2 || (reduceMotion && reduceMotion.matches)) return;
    var delay = (parseInt(box.getAttribute('data-seg'), 10) || 3) * 1000;
    var i = 0, timer, espera, visible = false;
    function go() {
      var sig = slides[(i + 1) % n], img = sig.querySelector('img');
      cargarHs(sig);
      if (img && !img.complete) return; // ảnh chưa tải xong → giữ ảnh hiện tại, thử lại nhịp sau
      slides[i].classList.remove('on');
      i = (i + 1) % n;
      slides[i].classList.add('on');
      cargarHs(slides[(i + 1) % n]);
    }
    function start() {
      stop();
      cargarHs(slides[(i + 1) % n]);
      espera = setTimeout(function () { timer = setInterval(go, delay); }, (idx % 4) * 500);
    }
    function stop() { clearTimeout(espera); clearInterval(timer); }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) start(); else stop();
      }, { rootMargin: '100px' });
      io.observe(box);
    } else { trasCarga(start); }
    box._orvCs = { stop: function () { stop(); if (io) io.disconnect(); box._orvCs = null; } };
  }

  /* ── Cómo comprar: nền xanh chạy lần lượt 1 → 2 → 3 → lặp ── */
  function initPasos(sec) {
    if (sec._orvPasos) return;
    var pasos = sec.querySelectorAll('.orv-paso');
    if (pasos.length < 2 || (reduceMotion && reduceMotion.matches)) return;
    var i = -1;
    var timer;
    function go() {
      if (pasos[i]) pasos[i].classList.remove('orv-activo');
      i = (i + 1) % pasos.length;
      pasos[i].classList.add('orv-activo');
    }
    sec.classList.add('orv-animando');
    go();
    timer = setInterval(go, 1600);
    sec._orvPasos = {
      stop: function () {
        clearInterval(timer);
        sec.classList.remove('orv-animando');
        pasos.forEach(function (p) { p.classList.remove('orv-activo'); });
        sec._orvPasos = null;
      }
    };
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-orv-anuncio]').forEach(initAnuncio);
    scope.querySelectorAll('[data-orv-header]').forEach(initMenu);
    scope.querySelectorAll('[data-orv-pasos]').forEach(initPasos);
    scope.querySelectorAll('[data-orv-hero-slides]').forEach(initHeroSlides);
    scope.querySelectorAll('[data-orv-col-slides]').forEach(initColSlides);
    scope.querySelectorAll('[data-orv-rv-pool]').forEach(initRvPool);
    watchHeights();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* ── Theme Editor ── */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var track = e.target.querySelector('.orv-an-track');
    if (track && track._orv) track._orv.stop();
    var pasos = e.target.querySelector('[data-orv-pasos]');
    if (pasos && pasos._orvPasos) pasos._orvPasos.stop();
    var hs = e.target.querySelector('[data-orv-hero-slides]');
    if (hs && hs._orvHs) hs._orvHs.stop();
    e.target.querySelectorAll('[data-orv-col-slides]').forEach(function (b) { if (b._orvCs) b._orvCs.stop(); });
    setTimeout(watchHeights, 0);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var hsBox = e.target.closest && e.target.closest('[data-orv-hero-slides]');
    if (hsBox && hsBox._orvHs) {
      hsBox._orvHs.show(Array.prototype.indexOf.call(hsBox.querySelectorAll('.orv-hs-slide'), e.target));
      return;
    }
    var block = e.target;
    var track = block.parentElement;
    if (!track || !track.classList.contains('orv-an-track') || !track._orv) return;
    track._orv.show(Array.prototype.indexOf.call(track.children, block));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hsBox = e.target.closest && e.target.closest('[data-orv-hero-slides]');
    if (hsBox && hsBox._orvHs) { hsBox._orvHs.auto(); return; }
    var root = e.target.closest('[data-orv-anuncio]');
    var track = root && root.querySelector('.orv-an-track');
    if (track && track._orv) track._orv.auto();
  });
})();
